import { render } from "./SidenavAnnouncement.vue?vue&type=template&id=6e2f5435&scoped=true"
import script from "./SidenavAnnouncement.vue?vue&type=script&lang=js"
export * from "./SidenavAnnouncement.vue?vue&type=script&lang=js"

import "./SidenavAnnouncement.vue?vue&type=style&index=0&id=6e2f5435&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2f5435"]])

export default __exports__